var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('text-loading-placeholder'):_c('div',{attrs:{"title":_vm.castNestedValue(_vm.content)}},[_vm._v("\n    "+_vm._s(_vm.castNestedValue(_vm.content))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }